export default __webpack_public_path__ + "62c101ca14dfa68db1deab63a053a400.svg";